<template>
  <v-row class="pa-5" v-if="doc">
    <v-col cols="12">
      <h2>Roll out summary</h2>
    </v-col>

    <v-col cols="11">
      <div class="">

        <div v-for="(col, index) in doc.list" :key="`priority-col-${col}-${index}`" class="flex-1 mb-12">
          <h2 class="text-h5 mb-2">{{ col.title }}</h2>
          <ResultsRow v-for="child in col.children" :key="`${col.id}-${child.id}`" :doc="doc" :child="child"
            :col="col.id" :parent="true" class="parent">
            <ResultsRow v-for="sub in child.children" :key="`${col.id}-${child.id}-${sub.id}`" :doc="doc" :child="sub"
              :col="child.id" />
          </ResultsRow>

        </div>

      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from "vuex";
const fb = require("@/firebaseConfig.js");

import ResultsRow from "./ResultsRow.vue";

export default {
  name: "RollOutVersion",
  data() {
    return {
      doc: null,
      docId: null,
      refDoc: null,
      collection: fb.rollOutExCollection,
    };
  },
  components: {
    ResultsRow
  },
  props: {
    uid: String,
    id: String,
  },
  watch: {
    uid(uid) {
      console.log('currentVersion changed', uid)
      this.getExercise()
    }
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  methods: {
    getExercise() {
      console.log("get exercise", this.uid);
      let ref = this.collection.where("id", "==", this.uid);
      ref.onSnapshot((querySnapshot) => {
        let items = [];
        querySnapshot.forEach((docs) => {
          let doc = docs.data();
          items.push(doc);
        });
        console.log('items', items)
        this.doc = items[0].doc;
      });
    },
  },
};
</script>

<style lang="scss">
.block {
  display: block;
}

.bars {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  margin: 0;
  padding: 0;
  width: 100%;
  margin-bottom: 0.8rem;

  .slice {
    list-style: none;
    margin: 0;
    padding: 0;
    flex: 1;
    height: 2rem;
    width: 100%;
    background: rgb(43, 43, 43);
    border-right: 2px solid black;
    display: flex;
    align-items: center;
    padding-left: 0.5rem;

    span {
      font-size: 0.7rem;
      color: black;
    }
  }

  .label {
    list-style: none;
    margin: 0;
    padding: 0;
    flex: 1;
    height: 1rem;
    width: 100%;
    font-size: 0.8rem;
    margin-bottom: 0rem;
    margin-top: 1rem;
  }

}

.text-sm {
  font-size: .9rem;
  margin-bottom: 0.4rem !important;
  padding-bottom: 0;
}

.text-md {
  font-size: 1.2rem;
  margin-bottom: 0rem !important;
  padding-bottom: 0 !important;
  line-height: 1;
}

.parent {
  border-bottom: 2px solid white;
  padding-bottom: 1rem;
  margin-bottom: 1rem;
}
</style>